import { render, staticRenderFns } from "./FrequentlyQuestions.vue?vue&type=template&id=0c066daa&scoped=true&"
import script from "./FrequentlyQuestions.vue?vue&type=script&lang=js&"
export * from "./FrequentlyQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyQuestions.vue?vue&type=style&index=0&id=0c066daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c066daa",
  null
  
)

export default component.exports